customElements.component = 'new-collection-template';

if (!customElements.get(customElements.component)) {
  class NewCollectionTemplate extends HTMLElement {
    constructor() {
      super();
      this.html = document.querySelector('html');
      this.productsPerPage = Number(this.getAttribute('data-products-per-page')) || 6;
      this.sortSelect = this.querySelector('.js-sort-select');
      this.loadMoreBtn = this.querySelector('.js-load-more-btn');
      this.productsCount = this.querySelector('.js-collection-products-count');
      this.filters = this.querySelector('.js-filters');
      this.filtersMobileButton = this.querySelector('.js-filters-mobile-button');
      this.filtersMobileClose = this.querySelector('.js-filters-mobile-close');
      this.filtersApply = this.querySelector('.js-filters-apply');
      this.filtersAccordions = this.querySelectorAll('.js-filters-accordion');
      this.filtersInputs = this.querySelectorAll('.js-filters-input');
      this.rangeSliders = this.querySelectorAll('.range-slider');
      this.emptyAlert = this.querySelector('.collection-empty');
      this.filtersMain = this.querySelector('.js-new-collection-filters__main');
    }

    updateUrl(url) {
      window.history.pushState({}, '', url);
    }

    updateFilterCounts(doc) {
      const newFilterCounts = doc.querySelectorAll('[data-filter-count-name]');
      newFilterCounts.forEach(newCountEl => {
        const name = newCountEl.getAttribute('data-filter-count-name');
        const currentCountEl = this.querySelector(`[data-filter-count-name="${name}"]`);
        if (currentCountEl) {
          currentCountEl.innerHTML = newCountEl.innerHTML;
          const input = currentCountEl.closest('label').querySelector('input.js-filters-input');
          if (input) {
            const count = parseInt(currentCountEl.textContent.replace(/[()]/g, ''));
            if (count === 0) {
              input.setAttribute('disabled', '');
            } else {
              input.removeAttribute('disabled');
            }
          }
        }
      });
    }

    async fetchSectionAndUpdate(url, updateDomCallback) {
      url.searchParams.set('section_id', this.dataset.sectionId);
      const fetchUrl = `${url.pathname}${url.search}`;
      const req = await fetch(fetchUrl);
      const res = await req.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(res, 'text/html');
      url.searchParams.delete('section_id');
      url.searchParams.delete('page');
      this.updateUrl(url.pathname + url.search);
      if (typeof updateDomCallback === 'function') {
        updateDomCallback(doc);
      }
    }

    initFilters() {
      this.rangeSliders && this.rangeSliders.forEach(slider => {
        new PriceRangeSlider(slider, (min, max) => {
          if (this.filtersMain) this.filtersMain.classList.add('is-loading');

          const url = new URL(window.location.href);
          url.searchParams.set('filter.v.price.gte', min);
          url.searchParams.set('filter.v.price.lte', max);
          url.searchParams.delete('page');

          this.fetchSectionAndUpdate(url, (doc) => {
            const newProducts = doc.querySelector('.js-collection-products');
            const newProductsCount = doc.querySelector('.js-collection-products-count');
            const currentProducts = this.querySelector('.js-collection-products');
            const collectionProductGrid = doc.querySelector('.js-collection-products-grid');
            if (collectionProductGrid.innerHTML.trim() != '') {
              if (newProducts && currentProducts) {
                currentProducts.innerHTML = newProducts.innerHTML;
                this.productsCount && (this.productsCount.innerHTML = newProductsCount.innerHTML);
                this.loadMoreBtn = this.querySelector('.js-load-more-btn');
                this.loadMoreBtn && this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
                this.setupInfiniteScroll();
                this.updateFilterCounts(doc);
              }
              this.querySelector('.new-collection-template-wrapper').style.display = 'block';
              this.emptyAlert.style.display = 'none';
            } else {
              this.emptyAlert.style.display = 'block';
              this.querySelector('.new-collection-template-wrapper').style.display = 'none';
              this.updateFilterCounts(doc);
            }
            if (this.filtersMain) this.filtersMain.classList.remove('is-loading');
          });
        });
      });

      this.filtersMobileButton && this.filtersMobileButton.addEventListener('click', () => {
        this.filters.classList.add('open');
        this.html.classList.add('overflow-hidden');
      });

      this.filtersMobileClose && this.filtersMobileClose.addEventListener('click', () => {
        this.filters.classList.remove('open');
        this.html.classList.remove('overflow-hidden');
      });
      
      this.filtersApply && this.filtersApply.addEventListener('click', () => {
        this.filters.classList.remove('open');
        this.html.classList.remove('overflow-hidden');
      });

      this.filtersAccordions && this.filtersAccordions.forEach((accordion) => {
        const accordionTitle = accordion.querySelector('.js-filters-accordion-title');

        accordionTitle && accordionTitle.addEventListener('click', () => {
          accordion.classList.toggle('open');
        });
      });

      this.filtersInputs && this.filtersInputs.forEach((input) => {
        input.addEventListener('change', async (e) => {
          if (this.filtersMain) this.filtersMain.classList.add('is-loading');

          const checked = e.target.checked;
          const name = e.target.name;
          const selectedValue = e.target.value;
          const url = new URL(window.location.href);
          url.searchParams.delete('page');

          if (checked) {
            url.searchParams.append(name, selectedValue);
          } else {
            const values = url.searchParams.getAll(name);
            url.searchParams.delete(name);
            values.forEach(value => {
              if (value !== selectedValue) {
                url.searchParams.append(name, value);
              }
            });
          }

          this.fetchSectionAndUpdate(url, (doc) => {
            const newProducts = doc.querySelector('.js-collection-products');
            const newProductsCount = doc.querySelector('.js-collection-products-count');
            const currentProducts = this.querySelector('.js-collection-products');
            if (newProducts && currentProducts) {
              currentProducts.innerHTML = newProducts.innerHTML;
              this.productsCount && (this.productsCount.innerHTML = newProductsCount.innerHTML);
              this.loadMoreBtn = this.querySelector('.js-load-more-btn');
              this.loadMoreBtn && this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
              this.setupInfiniteScroll();
              this.updateFilterCounts(doc);
            }
            if (this.filtersMain) this.filtersMain.classList.remove('is-loading');
          });
        });
      });
    }

    async handleSortBy(e) {
      const selectedValue = e.target.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', selectedValue);
      url.searchParams.delete('page');

      this.fetchSectionAndUpdate(url, (doc) => {
        const newProducts = doc.querySelector('.js-collection-products-grid');
        const currentProducts = this.querySelector('.js-collection-products-grid');
        const newProductsCount = doc.querySelector('.js-collection-products-count');
        const newLoadMoreBtn = doc.querySelector('.js-load-more-btn');

        if (newProducts && currentProducts) {
          currentProducts.innerHTML = newProducts.innerHTML;
          if (this.loadMoreBtn) {
            this.loadMoreBtn.remove();
          }
          if (newLoadMoreBtn) {
            currentProducts.parentNode.appendChild(newLoadMoreBtn.cloneNode(true));
            this.loadMoreBtn = this.querySelector('.js-load-more-btn');
            this.loadMoreBtn && this.loadMoreBtn.addEventListener('click', this.handleLoadMore.bind(this));
          } else {
            this.loadMoreBtn = null;
          }
          if (this.productsCount && newProductsCount) {
            this.productsCount.innerHTML = newProductsCount.innerHTML;
          }
          if (this.emptyAlert) this.emptyAlert.style.display = 'none';
          this.setupInfiniteScroll();
          this.updateFilterCounts(doc);
        } else {
          if (this.emptyAlert) this.emptyAlert.style.setProperty('display', 'block', 'important');
          this.querySelector('.new-collection-template-wrapper').style.display = 'none';
        }
      });
    }

    addEventListeners() {
      this.querySelectorAll('.js-sort-select').forEach(select => {
        select.addEventListener('change', this.handleSortBy.bind(this));
      });
    }

    setupInfiniteScroll() {
      if (this.infiniteScrollObserver) {
        this.infiniteScrollObserver.disconnect();
      }
      this.loadMoreBtn = this.querySelector('.js-load-more-btn');
      if (!this.loadMoreBtn) return;
      this.infiniteScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.handleLoadMore();
          }
        });
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      });
      this.infiniteScrollObserver.observe(this.loadMoreBtn);
    }

    connectedCallback() {
      this.addEventListeners();
      this.initFilters();
      this.setupInfiniteScroll();
    }

    async handleLoadMore() {
      const currentPage = Number(this.loadMoreBtn.getAttribute('data-current-page')) || 1;
      const totalPages = Number(this.loadMoreBtn.getAttribute('data-total-pages')) || 1;

      if (currentPage < totalPages) {
        const nextPage = currentPage + 1;
        const url = new URL(window.location.href);
        url.searchParams.set('page', nextPage);

        this.fetchSectionAndUpdate(url, (doc) => {
          const newProducts = doc.querySelector('.js-collection-products-grid');
          const currentProducts = this.querySelector('.js-collection-products-grid');
          const newProductsCount = doc.querySelector('.js-collection-products-count');
          const newLoadMoreBtn = doc.querySelector('.js-load-more-btn');

          if (newLoadMoreBtn) {
            const newCurrentPage = Number(newLoadMoreBtn.getAttribute('data-current-page')) || 1;
            const newTotalPages = Number(newLoadMoreBtn.getAttribute('data-total-pages')) || 1;
            this.loadMoreBtn && this.loadMoreBtn.setAttribute('data-current-page', newCurrentPage);
            this.loadMoreBtn && this.loadMoreBtn.setAttribute('data-total-pages', newTotalPages);

            if (newCurrentPage >= newTotalPages) {
              this.loadMoreBtn && this.loadMoreBtn.remove();
              if (this.infiniteScrollObserver) {
                this.infiniteScrollObserver.disconnect();
              }
            }

            this.productsCount && (this.productsCount.innerHTML = newProductsCount.innerHTML.replace(` ${this.productsPerPage * (newCurrentPage - 1)}-`, ` 1-`));
          } else {
            this.loadMoreBtn && this.loadMoreBtn.remove();
            this.productsCount && (this.productsCount.innerHTML = newProductsCount?.innerHTML.replace(` ${this.productsPerPage * currentPage}-`, ` 1-`));
            if (this.infiniteScrollObserver) {
              this.infiniteScrollObserver.disconnect();
            }
          }

          if (newProducts && currentProducts) {
            currentProducts.innerHTML += newProducts.innerHTML;
            const emptyAlert = this.emptyAlert;
            if (emptyAlert) emptyAlert.style.display = 'none';
            this.setupInfiniteScroll();
            this.updateFilterCounts(doc);
          } else {
            const emptyAlert = this.emptyAlert;
            if (emptyAlert) emptyAlert.style.setProperty('display', 'block', 'important');
            this.querySelector('.new-collection-template-wrapper').style.display = 'none';
          }
        });
      } else {
        this.loadMoreBtn && this.loadMoreBtn.remove();
        if (this.infiniteScrollObserver) {
          this.infiniteScrollObserver.disconnect();
        }
      }
    }
  }

  class PriceRangeSlider {
    constructor(container, onChange) {
      this.container = container;
      this.rangeMin = container.querySelector('.range-min');
      this.rangeMax = container.querySelector('.range-max');
      this.rangeValueMin = container.querySelector('.range-value-min');
      this.rangeValueMax = container.querySelector('.range-value-max');
      this.sliderRange = container.querySelector('.slider-range');
      this.minGap = 1;
      this.onChange = onChange;
  
      if (this.rangeMin && this.rangeMax && this.sliderRange) {
        this.rangeMin.addEventListener('input', this.updateSlider.bind(this));
        this.rangeMax.addEventListener('input', this.updateSlider.bind(this));
        this.rangeMin.addEventListener('change', this.applyFilter.bind(this));
        this.rangeMax.addEventListener('change', this.applyFilter.bind(this));
        this.updateSlider();
      }
    }
  
    updateSlider(event) {
      let min = parseInt(this.rangeMin.value);
      let max = parseInt(this.rangeMax.value);
      let minLimit = parseInt(this.rangeMin.min);
      let maxLimit = parseInt(this.rangeMax.max);
  
      if (max - min < this.minGap) {
        if (event && event.target === this.rangeMin) {
          this.rangeMin.value = max - this.minGap;
        } else {
          this.rangeMax.value = min + this.minGap;
        }
        min = parseInt(this.rangeMin.value);
        max = parseInt(this.rangeMax.value);
      }
  
      const percentMin = ((min - minLimit) / (maxLimit - minLimit)) * 100;
      const percentMax = ((max - minLimit) / (maxLimit - minLimit)) * 100;
  
      this.sliderRange.style.left = percentMin + '%';
      this.sliderRange.style.width = (percentMax - percentMin) + '%';
  
      this.rangeValueMin.textContent = `$${min}`;
      this.rangeValueMax.textContent = `$${max}`;

      // Position the labels above the thumbs
      if (this.rangeValueMin && this.rangeValueMax) {
        this.rangeValueMin.style.left = `calc(${percentMin}% )`;
        this.rangeValueMax.style.left = `calc(${percentMax}% )`;
      }
    }
  
    applyFilter() {
      if (typeof this.onChange === 'function') {
        let min = parseFloat(this.rangeMin.value);
        let max = parseFloat(this.rangeMax.value);
        let maxLimit = parseFloat(this.rangeMax.max);
  
        let minForUrl = min.toFixed(2);

        let maxForUrl;
        maxForUrl = max.toFixed(2);
    
        this.onChange(minForUrl, maxForUrl);
      }
    }
  }

  customElements.define(customElements.component, NewCollectionTemplate);
}